import React from "react";

import { Limit } from "../Limit";

export default function MinQuantityLimit({
  limits,
  canEdit = true,
  hasError,
  handleChange,
  handleValid,
}) {
  return (
    <Limit
      id="minimum"
      inputName="minQuantity"
      switchName="hasMinQuantity"
      label="Minimum"
      limits={limits}
      canEdit={canEdit}
      hasError={hasError}
      handleChange={handleChange}
      handleValid={handleValid}
    />
  );
}
